<button
  mat-icon-button
  [matTooltip]="!!locked ? 'Unlock' : 'Lock'"
  [intercomTarget]="'toolbar-context-menu-lock'"
  (click)="lockedChanged.emit(!locked)"
>
  <fa-icon [icon]="!!locked ? ['far', 'unlock-alt'] : ['far', 'lock-alt']"></fa-icon>
</button>
